import {
    EnvironmentProviders,
    inject,
    makeEnvironmentProviders,
    provideAppInitializer,
    provideEnvironmentInitializer
} from '@angular/core';
import { ProcessorService } from './processor.service';

export function provideDfNg(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideEnvironmentInitializer(() => {
            inject(ProcessorService);
        }),
        provideAppInitializer(() => {
            ProcessorService.ready();
        })
    ]);
}
